export default __webpack_public_path__ + "assets/editing.5ff8c4acc77a4903aa909c214e1c26c9.png";